// extracted by mini-css-extract-plugin
export default {"faq":"KMsC7","faqTitle":"a3zpH","skeleton-progress":"_8f-w9"};